module.exports = __webpack_public_path__ + "static/media/rewards_premium_suscribed.0b9f8da1.png";